
import { Link, useLocation } from "react-router-dom";
import React  from 'react'
import moment from 'moment'
import { useQuery } from '@apollo/client';
import { useAuthContext } from '../../../../context/AuthContext';
import { ConvertToCloudFrontUrl } from "../../../../utils/ConvertToCloudFrontUrl"
import { GET_AVATAR_USER_MANAGE } from '../../../../graphql-client/Queries';
import { getFileExtension } from "../../../../utils/FileUtils";

export default React.memo(function VideoCard(props) {
    const location = useLocation();
    const thumbnail = props.thumbnail? ConvertToCloudFrontUrl(props.thumbnail) : "https://data.linklearn.vn/content.png"
    
    const avatarUser = ConvertToCloudFrontUrl(props.avatarUser)
    const {isAuthenticated} = useAuthContext() 
    const {data} = useQuery(GET_AVATAR_USER_MANAGE)
    
     // Xác định loại tài liệu đính kèm
    const documentType = props.document ? getFileExtension(props.document) : null;
    
    const handleNoWatchTime = () => {
        !isAuthenticated?
        alert("Bạn chưa đăng nhập hoặc đăng ký? Hay đăng nhập để xem tài liệu")
        :alert("Bạn đã hết thời lượng xem video bài giảng trong tháng, vui lòng mua thêm thời lượng để xem video, hoặc xem file pdf trong phần 'Tài Liệu' bên dưới.");
    };
    function saveScrollPosition(location, idUser) {
    if (location.pathname.startsWith("/user/")) {
        sessionStorage.setItem('videoListScroll_' + idUser, window.scrollY);
    }
    }
     // Render thumbnail với overlay icon
    const renderThumbnail = () => {
        return (
            <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                <img 
                    className="videoCard_thumbnail" 
                    alt={'Ảnh của ' + props.title} 
                    src={thumbnail} 
                />
                
                {/* Overlay cho PDF */}
                {documentType === 'pdf' && (
                    <div className="document-badge pdf">
                        <i className="fas fa-file-pdf"></i>
                        <span>PDF</span>
                    </div>
                )}
                
                {/* Overlay cho Excel (Quiz) */}
                {(documentType === 'excel' || documentType === 'docx') && (
                    <div className="document-badge quiz">
                        <i className="fas fa-check-circle"></i>
                        <span>QUIZ</span>
                    </div>
                )}
            </div>
        );
    };
    return (
        <div 
            className={ 
                props.nextVideo 
                ? 
                "col-12 me-auto" 
                :
                "col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-6 col-6 mx-auto"
            }
        >
            <div 
                className="videoCard m-1 mt-2 p-1"
            >
                {/* {data && data.userManage.monthlyWatchTime && data.userManage.monthlyWatchTime > 0  ? */}
              
                <Link
                to={{
                    pathname: "/watching/" + props.videoId,
                    state: {
                    fromUserVideoList: true,
                    loadedCount: props.buttonStatus?.isCountListVideoDoClick,
                    openedVideoListIds: props.openedVideoListIds
                    }
                }}
                onClick={() => saveScrollPosition(location, props.idUser)}
                >
                    {renderThumbnail()}
                </Link>
                {/* :
                <div onClick={handleNoWatchTime}>
                    {renderThumbnail()}
                </div> */}
                {/* } */}
                <div className="videoCard_info d-flex ">
                    {
                        avatarUser !== "/default-avatar.png" && !props.publishVideoManager &&
                        <Link to = {"/user/"+ props.idUser}  
                        onClick={() => saveScrollPosition(location, props.idUser)}
                        >
                            <img className="img-video_avatar rounded-circle" alt={`Avatar of user ${props.idUser}`}  src={avatarUser} data-bs-dismiss="modal"/>
                        </Link>
                    }
                    <div className="videoCard_info_text">
                        {/* {data && data.userManage.monthlyWatchTime && data.userManage.monthlyWatchTime > 0  ? */}
                        <Link className="nameUser" to = {"/watching/" + props.videoId} 
                         onClick={() => saveScrollPosition(location, props.idUser)}
                        >
                            <b className="Title_video" data-bs-dismiss="modal" title={props.title}>
                                {props.title}
                            </b>
                        </Link>
                        {/* :<div className="nameUser" onClick={handleNoWatchTime}>
                            <b className="Title_video" data-bs-dismiss="modal" title={props.title}>
                                {props.title}
                            </b>
                        </div> */}
                        {/* // } */}
                        {
                            !props.publishVideoManager   && 
                            <Link to = {"/user/"+ props.idUser} className="nameUser">
                                 {props.username}
                            </Link>
                        }
                        {
                                   props.tags && props.tags.length >=1 && 
                                    <b className=" tags_video">{props.tags}</b>
                                }
                            <div className="d-flex justify-content-between">
                                
                                {
                                    props.publishVideoManager && 
                                        <div className="btn-group dropup">
                                            <button type="button" title="Chỉnh sửa video" className="btn rounded ps-1 pe-1" data-bs-toggle="dropdown" aria-expanded="true">
                                                <i className="fa fa-wrench" aria-hidden="true"></i>
                                            </button>
                                            <ul className="dropdown-menu">
                                                <li>
                                                    <button 
                                                            onClick={()=>props.isShowFormDeleteVideo()}
                                                            className="btn btn-light w-100 " data-bs-toggle="modal" type="button" 
                                                            data-bs-target={props.videoIdInFormDelete
                                                                ?"#deleteVideoManager"+ props.videoIdInFormDelete
                                                                : "#deleteVideoManager-default"}
                                                    >
                                                        <i className="fa fa-trash" aria-hidden="true"></i> Xóa 
                                                    </button>
                                                </li>
                                                <li>
                                                    <button 
                                                        onClick={()=>props.isShowFormUpdateVideo()}
                                                        className="btn btn-light w-100 mt-1" type="button" data-bs-toggle="modal" 
                                                        data-bs-target={
                                                            props.videoIdInFormState
                                                            ? "#publishVideoManager"+props.videoIdInFormState
                                                            : "#publishVideoManager-default"
                                                            } 
                                                        >
                                                        <i className="fas fa-pen" /> Sửa 
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                }
                            </div>
                        <div className="statisticalVideo d-flex flex-column">
                            <div className="d-flex align-items-center flex-wrap">
                                <div className="d-flex align-items-center me-2">
                                <p className="mb-0">{props.view}</p>&nbsp;
                                <p className="mb-0">views</p>
                                </div>
                                <div className="d-flex align-items-center me-2">
                                <p className="mb-0">{props.like}</p>&nbsp;
                                <p className="mb-0">Thanks</p>
                                </div>
                            </div>

                            <div className="text-muted small mt-1">
                                {moment(props.date).fromNow()}
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}
)